// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + (chunkId === 524 ? "app" : chunkId) + "." + {"314":"e00de36c4bf8a24ed9d0","524":"1b7fe774586b30fb2939"}[chunkId] + ".css";
};